<script setup lang="ts">
import { useI18n } from 'vue-i18n';

const { t: $t } = useI18n();
</script>

<template>
    <div class="item-root">{{ $t('barcode_only_mobile') }}</div>
</template>
